import { popup } from "../popup/view";



export function processGalleries(base = document) {
    const disp = (window.screen.width)<=480?'mobile':(window.screen.width)<=780?'tablet':'desktop';
    
    const initVideos = (el, resp) => {
        if(resp.hasVideo) {
            if(!resp.videoUpload&&resp.videoID) {
                if(resp.videoID.length==11) {
                    if(!window.youtubeAPI) {
                        window.youtubeAPI = document.createElement('script');
                        window.youtubeAPI.src = 'https://www.youtube.com/iframe_api';
                        document.getElementsByTagName('head')[0].appendChild(window.youtubeAPI);
                        window.youtubePlayers = [];
                        window.onYouTubeIframeAPIReady = () => {
                            youtubePlayers.forEach(p=>p.call());
                        }
                    }
                } else {
                    if(!window.vimeoAPI) {
                        window.vimeoAPI = document.createElement('script');
                        window.vimeoAPI.src = 'https://player.vimeo.com/api/player.js';
                        window.vimeoPlayers = [];
                        window.vimeoAPI.onload = () => {
                            vimeoPlayers.forEach(p=>p.call());
                        };
                        document.getElementsByTagName('head')[0].appendChild(window.vimeoAPI);
                    }
                }
            }
            if(resp.videoLightbox) {
                el.onclick = () => {
                    if(window.attsList) {
                        window.attsList.video = '<div class="video_popup"></div>';
                    } else {
                        window.attsList = {video:'<div class="video_popup"></div>'};
                    }
                    popup(window.videoPopupId,[],p=>{
                        const video_container = p.querySelector('.video_popup');
                        let video = document.createElement('div');
                        video.style.background = 'black';
                        if(resp.videoUpload&&resp.videoURL) {
                            video = document.createElement('video');
                            video.src = resp.videoURL;
                            video.controls = true;
                            video.loop = true;
                        }
                        video_container.style.width = "100%";
                        video_container.style.height = "0";
                        video_container.style.paddingBottom = "56.25%";
                        video.style.position = "absolute";
                        video.style.left = 0;
                        video.style.top = 0;
                        video.style.width = "100%";
                        video.style.height = "100%";
                        video_container.appendChild(video);
                        if(resp.videoUpload&&resp.videoURL&&resp.videoAutoplay) { video.play(); }
                        if(!resp.videoUpload&&resp.videoID) {
                            if(resp.videoID.length==11) {
                                const player = new YT.Player(video, {
                                    videoId: resp.videoID,
                                    playerVars: {
                                        loop: true,
                                        playlist: resp.videoID,
                                        playsinline: true,
                                        controls: !resp.videoAutoplay
                                    },
                                    events: {
                                        onReady: (event) => {
                                            if(resp.videoAutoplay) {
                                                event.target.playVideo();
                                            }
                                        }
                                    }
                                });
                            } else {
                                const player = new Vimeo.Player(video, {
                                    id: resp.videoID,
                                    autoplay: resp.videoAutoplay,
                                    loop: true
                                });
                            }
                        }
                    });
                }
            } else {
                if(resp.videoUpload&&resp.videoURL) {
                    const video = el.querySelector('video');
                    video.loop=true;
                    if(resp.videoAutoplay) {
                        video.parentNode.classList.add('active');
                        video.controls = false;
                        video.muted = true;
                        video.play();
                    } else {
                        el.onclick = () => {
                            const video = el.querySelector('video');
                            video.parentNode.classList.add('active');
                            video.play();
                            el.onclick = null;
                        }
                    }
                }
                if(!resp.videoUpload&&resp.videoID) {
                    if(resp.videoID.length==11) {
                        const player = ()=>{
                            const video = document.querySelector('#video_'+resp.videoID);
                            const player = new YT.Player(video, {
                                videoId: resp.videoID,
                                playerVars: {
                                    loop: true,
                                    playlist: resp.videoID,
                                    playsinline: true,
                                    controls: !resp.videoAutoplay
                                },
                                events: {
                                    onReady: (event) => {
                                        const video = document.querySelector('#video_'+resp.videoID);
                                        if(resp.videoAutoplay) {
                                            video.parentNode.classList.add('active');
                                            event.target.mute(true);
                                            event.target.playVideo();
                                        } else {
                                            el.onclick = () => {
                                                video.parentNode.classList.add('active');
                                                event.target.playVideo();
                                            }
                                        }
                                    }
                                }
                            });
                        }
                        if(window.YT) { player.call(); } else { youtubePlayers.push(player); }
                    } else {
                        const player = () => {
                            const video = document.querySelector('#video_'+resp.videoID);
                            const player = new Vimeo.Player(video, {
                                id: resp.videoID,
                                background: resp.videoAutoplay,
                                muted: resp.videoAutoplay,
                                loop: true
                            });
                            if(resp.videoAutoplay) {
                                video.parentNode.classList.add('active');
                            } else {
                                el.onclick = () => {
                                    video.parentNode.classList.add('active');
                                    player.play();
                                }
                            }
                        }
                        if(window.Vimeo) { player.call(); } else { vimeoPlayers.push(player); }
                    }
                }
            }
        }
    }
    base.querySelectorAll('.wp-block-smarttouch-gallery > div').forEach(el=>{
        const config = JSON.parse(LZUTF8.decompress(el.dataset.config,{inputEncoding:'Base64'}));
        let ratio = config[disp].ratio||config.desktop.ratio;
        if(ratio=='custom') ratio = config[disp].customRatio||config.desktop.customRatio;
        if(+(ratio)==0) ratio = '56.25';
        el.style.setProperty('--ratio',ratio+'%');
        el.style.setProperty('--count',el.querySelectorAll('.media').length);
        const gallery = [];
        config.media.forEach(i=>gallery.push({...config.meta[i].desktop}));
        if(el.classList.contains('is-type-slideshow')) {
            const initSlide = (swiper) => {
                const slide = swiper.slides[swiper.activeIndex];
                const image = slide.querySelector('img');
                const resp = JSON.parse(LZUTF8.decompress(image.dataset.resp,{inputEncoding:'Base64'}));
                initVideos(slide, resp);
            }
            let on = {
				lazyImageLoad: (swiper,slide,image) => {
					if(!image.dataset.resp) return;
					const resp = JSON.parse(LZUTF8.decompress(image.dataset.resp,{inputEncoding:'Base64'}));
                    let url = resp[disp].url||resp.desktop.url;
                    if(window.themefolder&&(image.width>5)&&(image.height>5)) {
                        url = window.themefolder+'image.php?w='+image.width+'&h='+image.height+'&src='+encodeURIComponent(url);
                    }
                    image.style.setProperty('--focalx',resp[disp].focalx*100+'%');
                    image.style.setProperty('--focaly',resp[disp].focaly*100+'%');
                    image.style.setProperty('--scale',resp[disp].scale);
					image.setAttribute('src',url);
                    if(resp.hasVideo) initVideos(slide, resp);
				},
                afterInit: (swiper) => { initSlide(swiper); },
                slideChange: (swiper) => { initSlide(swiper); },
                click: (swiper, event) => {
                    if(el.classList.contains('click-to-expand')&&event.path&&event.path[2]&&event.path[2].classList.contains('swiper-slide')) {
                        popupGallery(event.path[2].getAttribute('data-swiper-slide-index'), gallery);
                    }
                }
			}
            if(config.verticalParallax) {
                ScrollTrigger.create({
                    id: 'verticalParallax',
                    trigger: el,
                    start: 'top top',
                    end: 'bottom top',
                    scrub: true,
                    onUpdate: (e) => {
                        const top = Math.round(e.progress*el.offsetHeight/2) + 'px';
                        el.querySelectorAll('.media-wrapper figure, .media-wrapper iframe, .media-wrapper video').forEach(el=>el.style.transform = "translateY("+top+")");
                    }
                })
            }
            if(config.horizontalParallax&&(config.swiper.effect!='coverflow')) {
                on = lodash.merge(on,{
                    progress: function(swiper, progress) {
                        for (let i = 0; i < swiper.slides.length; i++) {
                            let slideProgress = swiper.slides[i].progress, innerOffset = swiper.width * 0.5, innerTranslate = slideProgress * innerOffset;
                            swiper.slides[i].querySelector("figure").style.transform = "translate3d(" + innerTranslate + "px,0,0)";
                        };
                    },
                    touchStart: function(swiper, event) {
                        for (let i = 0; i < swiper.slides.length; i++) {
                            swiper.slides[i].style.transition = "";
                        }
                    },
                    setTransition: function(swiper, speed) {
                        for (let i = 0; i < swiper.slides.length; i++) {
                            swiper.slides[i].style.transition = speed + "ms";
                            swiper.slides[i].querySelector("figure").style.transition = speed + "ms";
                        }
                    }
                });
            }
            var slideCount = el.querySelectorAll('.swiper-slide').length;
            if(config.swiper.slidesPerViewMobile) config.swiper.breakpoints = {
                0: { slidesPerView: config.swiper.slidesPerViewMobile },
                480: { slidesPerView: config.swiper.slidesPerView }
            }
            var swiper = new Swiper(el,lodash.merge(config.swiper,{
				preloadImages: false,
				lazy: {
					loadPrevNext: true
				},
				watchSlidesProgress: true,
                centerMode: true,
                loop: (slideCount>1)?true:false,
				on: on
			}));
        } else {
            el.firstChild.classList.add('cols'+config[disp].columns);
			el.querySelectorAll('[data-resp]').forEach((i,index)=>{
				const resp = JSON.parse(LZUTF8.decompress(i.dataset.resp,{inputEncoding:'Base64'}));
                const url = resp[disp].url||resp.desktop.url;
				i.style.setProperty('--focalx',resp[disp].focalx*100+'%');
				i.style.setProperty('--focaly',resp[disp].focaly*100+'%');
				i.style.setProperty('--scale',resp[disp].scale);
                if(el.classList.contains('click-to-expand')) {
                    i.onclick = function(){
                        popupGallery(index, gallery);
                    }
                }
                ScrollTrigger.create({
                    trigger: i,
                    start: 'top bottom-=100px',
                    showTriggers: true,
                    once: true,
                    onEnter: () => {
                        const img = document.createElement('img');
                        img.onload = () => {
                            i.src = img.src;
                            i.parentNode.classList.add('loaded');
                        }
                        if(window.themefolder&&(i.width>5)&&(i.height>5)) {
                            img.src = window.themefolder+'image.php?w='+i.width+'&h='+i.height+'&src='+encodeURIComponent(url);
                        } else {
                            img.src = url;
                        }
                    }
                })
                initVideos(el, resp);
			});
        }
    });
}